import { Absolute, Flex, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

import { FASTLY_CROPS } from '../constants'

import { LockupPricelineVip } from '../svgr/logos'

const StyledContainer = styled(Flex).attrs(() => ({
  minHeight: [null, null, null, '480px'],
  pb: 5,
  px: 4,
}))`
  position: relative;
  background-image: ${({ imageSrc }) => `url(${imageSrc}?${FASTLY_CROPS.HERO_MOBILE})`};
  ${(props) => props.theme.mediaQueries.lg} {
    background-image: ${({ imageSrc }) => `url(${imageSrc}?${FASTLY_CROPS.HERO_LGXXL})`};
  }

  background-size: cover;
  background-position: center;
  z-index: 10;
  align-items: flex-start;
  ${(props) => props.theme.mediaQueries.xxl} {
    align-items: center;
  }
`

const Overlay = styled(Absolute)`
  opacity: 0.4;
`

const StyledHeroCopy = styled(Flex)`
  flex: 1 1 auto;
`

const StyledHeroContent = styled(Flex)`
  z-index: 11;
  flex-direction: column;
  ${(props) => props.theme.mediaQueries.xl} {
    flex-direction: row;
  }
`

const StyledLogos = styled(LockupPricelineVip)`
  height: 128px;
  width: 160px;
  font-size: 160px;
  svg {
    display: block;
  }
  ${(props) => props.theme.mediaQueries.lg} {
    font-size: 200px;
    width: 200px;
    height: 160px;
  }
  ${(props) => props.theme.mediaQueries.xl} {
    width: 250px;
    height: 200px;
    svg {
      display: unset;
    }
  }
  ${(props) => props.theme.mediaQueries.xxl} {
    font-size: 250px;
  }
`

const A11yWrap = styled.h1`
  margin: 0;
  padding: 0;
  margin-top: 24px;
  ${(props) => props.theme.mediaQueries.lg} {
    margin-top: 0;
  }
`

const Hero = ({ imageSrc, content }) => {
  return (
    <StyledContainer imageSrc={imageSrc} data-testid='hero-background-image'>
      <Overlay top={0} right={0} bottom={0} left={0} color='text.dark' />
      <StyledHeroContent
        height={['255px', null, '286px', '300px', '200px']}
        width={[1, null, 1 / 2, 1 / 2, 1 / 2, 3 / 5]}
      >
        <A11yWrap>
          <StyledLogos variation='vip' title='Priceline VIP' />
        </A11yWrap>
        <StyledHeroCopy
          flexDirection='column'
          mt={['20px', null, null, '40px', '40px', '80px']}
          pl={[0, null, null, null, 4]}
        >
          <Text color='#FFF100' fontSize={1} lineHeight={1.25}>
            {content.headingText}
          </Text>
          <Text color='text.lightest' fontSize={[3, 4]} lineHeight={[1.25, 1.4]}>
            {content.text}
          </Text>
        </StyledHeroCopy>
      </StyledHeroContent>
    </StyledContainer>
  )
}

export { Hero }
export default Hero
